module.exports = __webpack_public_path__ + "img/16.45fde082.jpg";